declare var require;

export class AnimationContents {
    public static GAMES_SCREEN_JSON = require("../../../animate/GameScreen.json");
    public static GAMES_STREET_JSON = require("../../../animate/GameStreet.json");
    public static INTRO_SCREEN_JSON = require("../../../animate/IntroScreen.json");
    public static PRELOADER_SCREEN_JSON = require("../../../animate/PreloaderScreen.json");
    public static PAUSE_SCREEN_JSON = require("../../../animate/Pause.json");
    public static RECORD_SCREEN_JSON = require("../../../animate/Record.json");
    public static SETTINGS_SCREEN_JSON = require("../../../animate/Settings.json");
    public static EXIT_GAME_SCREEN_JSON = require("../../../animate/ExitGame.json");
    public static EXIT_MENU_SCREEN_JSON = require("../../../animate/ExitMenu.json");
    public static CONNECTION_ERROR_SCREEN_JSON = require("../../../animate/ConnectionError.json");
    public static HELP_SCREEN_JSON = require("../../../animate/Help.json");
    public static MAIN_MENU_SCREEN_JSON = require("../../../animate/MainMenu.json");
    public static LOSE_WINDOW_SCREEN_JSON = require("../../../animate/LoseWindow.json");
    public static WIN_WINDOW_SCREEN_JSON = require("../../../animate/WinWindow.json");
    public static CHAR_CHOICE_SCREEN_JSON = require("../../../animate/CharChoice.json");
    public static TABLO_SCREEN_JSON = require("../../../animate/Tablo.json");
    public static MINI_GAME_SCREEN_JSON = require("../../../animate/MiniGame.json");
    public static GRASS_SCREEN_JSON = require("../../../animate/Grass.json");
}
